module.exports = __webpack_public_path__ + "static/media/glanum_bogen_tn.ffb3b35d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_bogen_tn.jpg
// module id = 712
// module chunks = 0